import { ProductCategoryContext } from './product-category-context';

export type ProductCategory = ProductCategoryContext['category'];
